export default __webpack_public_path__ + "static/media/kaikas-wallet.3f3d1909.svg";